// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { XNGAGE_ELEMENTS } from "@steiner/XDL/constants";
import { xClassNames } from "@steiner/XDL/Utilities";
import React, { FC } from "react";
import { useDispatch } from "react-redux";

const enum fields {
    isCompactHeader = "isCompactHeader",
}

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

interface SecondaryMainNavigationStyles {
    container?: InjectableCss;
    shopNowLink?: LinkPresentationProps;
    reorderLink?: LinkPresentationProps;
}

export const secondaryMainNavigationStyles: SecondaryMainNavigationStyles = {};

const styles = secondaryMainNavigationStyles;
const SecondaryMainNavigation: FC<Props> = props => {
    const dispatch = useDispatch();
    const { isInShell } = useShellContext();
    const { reorderPadPageUrl } = useAppSelector(state => ({
        reorderPadPageUrl: getPageLinkByPageType(state, "ReorderPadPage")?.url,
    }));

    const openDrawer = () => {
        dispatch(
            setNavDrawerIsOpen({
                navDrawerIsOpen: true,
                onComplete: () => {
                    setTimeout(() => {
                        const button = document.querySelector('[data-title="Shop Now"] + span') as HTMLButtonElement;
                        button?.click();
                    }, 150);
                },
            }) as any,
        );
    };

    return (
        <StyledWrapper {...styles.container} className={xClassNames.append(isInShell && "shell-editing")}>
            <Link {...styles.shopNowLink} onClick={openDrawer}>
                {translate("Shop Now")}
            </Link>
            <Link {...styles.reorderLink} href={reorderPadPageUrl}>
                {translate("Reorder")}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SecondaryMainNavigation,
    definition: {
        group: XNGAGE_ELEMENTS,
        icon: "magnifying-glass",
        fieldDefinitions: [],
    },
};

export default widgetModule;
